export default __webpack_public_path__ + "static/media/9.669029db.png";